export default () => {
    return {
        delay: 0,
        scrollTrigger: false,
        stSettings: false,

        mounted(delay = this.$store.animationDelay, scrollTrigger = true) {
            this.scrollTrigger = scrollTrigger;
            this.delay = delay;
            this.grow();
        },

        grow() {
            if (this.scrollTrigger) {
                this.stSettings = {
                    start: 'top 85%',
                    trigger: this.$refs.shape,
                    once: true
                };
            }

            gsap.to(this.$refs.start, {
                morphSVG: this.$refs.destination01,
                duration: 2.2,
                ease: 'circ.inOut',
                delay: this.delay,
                scrollTrigger: this.stSettings,
                onComplete: () => this.morph()
            });
        },

        morph() {
            let stSettings = false;

            if (this.scrollTrigger) {
                let stSettings = {
                    start: 'top bottom',
                    trigger: this.$refs.shape
                };
            }

            const itsMorphinTime = gsap.timeline({
                repeat: -1,
                yoyo: true,
                defaults: {
                    duration: 6,
                    ease: 'power1.inOut'
                },
                scrollTrigger: stSettings
            });

            itsMorphinTime
                .to(this.$refs.start, { morphSVG: this.$refs.destination02 })
                .to(this.$refs.start, { morphSVG: this.$refs.destination03 })
                .to(this.$refs.start, { morphSVG: this.$refs.destination01 });
        }
    };
};
